

import React, { useEffect } from 'react';
import styled from 'styled-components';

const HeroDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10vh 3vw 10vw 3vw;

  @media(max-width:1050px){
    padding: 8vh 6vw 10vh 6vw;
  }

  @media(max-width:576px){
    padding: 8vh 4vw 10vh 4vw;
  }
`;

const HeroHeading = styled.h2`
  font-size: 2rem;
  color: var(--secondary);
  margin-bottom: 5vh;
  text-align: center;

  @media(max-width:1050px){
    font-size: 1.8rem;
  }

  @media(max-width:576px){
    font-size: 1.4rem;
  }
`;

const ImgDiv = styled.div`
  position: relative;
  min-width: fit-content;
`;


const Img = styled.img`
  width: 20vw; /* Reduced from 25vw */
  height: auto;
  object-fit: contain;
  opacity: 0;
  transition: all 0.8s ease-in-out;

  &.appear {
    opacity: 1;
    transform: translateY(0);
  }

  @media(max-width:1050px){
    width: 30vw; /* Reduced from 40vw */
  }
  @media(max-width:576px){
    width: 50vw; /* Reduced from 60vw */
  }
`;

const RectLabel = styled.div`
  position: absolute;
  background-color: var(--secondary);
  color: #fff;
  padding: 1vh 1vw;
  border-radius: 10px;
  font-size: 14px;
  opacity: 0;
  transition: all 0.8s ease-in-out;

  &.appear-up {
    opacity: 1;
    transform: translateY(0);
  }

  @media(max-width:576px){
    font-size: 11px;
  }
`;

const Line = styled.svg`
  position: absolute;
  width: 12vw;
  height: 12vh;

  & path {
    stroke: var(--secondary);
    stroke-width: 2;
    fill: none;
  }

  @media(max-width:1050px){
    display: none;
  }
`;

const IRDHero = () => {
  const handleScroll = () => {
    const parent = document.getElementById('ird-hero-div');
    const img = document.getElementById('ird-img');
    const labels = [...document.querySelectorAll('.ird-label')];

    if(window.scrollY >= parent.offsetTop - 250){
      img?.classList.add('appear');
      labels.forEach(label => label.classList.add('appear-up'));
    } else {
      img?.classList.remove('appear');
      labels.forEach(label => label.classList.remove('appear-up'));
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <HeroDiv id="ird-hero-div">

      <HeroHeading>Economic Benefits</HeroHeading>

      <ImgDiv>
        <Img src="/images/pp.png" alt="IRD Machine" id="ird-img" />

     
        <RectLabel className="ird-label" style={{top: '10%', left: '-18vw'}}>
          Lower Operating Costs
          <Line><path d="M0 0 L100 50" /></Line>
        </RectLabel>
        <RectLabel className="ird-label" style={{top: '50%', left: '-18vw'}}>
          Reduced Labor & Training cost
          <Line><path d="M0 0 L100 50" /></Line>
        </RectLabel>

        <RectLabel className="ird-label" style={{bottom: '-8%', right: '50%', transform: 'translateX(-50%)'}}>
          Lower Risk = Lower Insurance & Compliance
          <Line><path d="M0 0 L0 0" /></Line>
        </RectLabel>

     
        <RectLabel className="ird-label" style={{top: '20%', right: '-18vw'}}>
          Higher Productivity & Faster Cycles
          <Line><path d="M0 0 L100 50" /></Line>
        </RectLabel>
        <RectLabel className="ird-label" style={{top: '55%', right: '-18vw'}}>
          Less Material Waste
          <Line><path d="M0 0 L100 50" /></Line>
        </RectLabel>

    
        
      </ImgDiv>
    </HeroDiv>
  );
};

export default IRDHero;